<template>
<div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
    <div id="TituloDetalleDeDocumento_div">
        <h5 style="margin-bottom: 0px;">SOLICITUDES EN DEVOLUCIÓN</h5>
        <h6 style="margin-top: 0px;">Gestión de Solicitudes de documentos</h6>
    </div>

    <div class="row d-flex">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
            <div class="area">
                    <h6>Solicitudes por Área</h6>
                        <CAreas
                            v-on:valorParaElPadre="cambioDeArea" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'filtroDeBusqueda_Area'" 
                            :parametros="BusquedaForm.parametros_Area" 
                            :valorDefinido="BusquedaForm.parametros_Area.areaId" 
                            
                            >
                        </CAreas>

                    <div id="BotonBusqueda_div" class="text-right">
                        <button class="btn btn-sm btn-dark"  @click='ObtenSolicitudes()'>Obtener Listado</button>
                    </div>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
            <div class="area" v-if="NoRegistradas.length>0">
                        <div>
                            <div v-if="listaPreviaSinFiltro.length>0">
                                <h6>Total de Documentos en Listado Obtenido : {{listaPreviaSinFiltro.length}}</h6>
                            </div>
                            <div v-if="ListadoDeFechas.length>0">
                                <div class="form-group col-4" >
                                    <label class="text-success">Fecha de Listado</label>
                                    <select id="catalogoDeTipos" class="form-control" @change="cambiarFechaListado($event)">
                                        <option value= -1>Seleccione una fecha</option>
                                        <option v-for="fechas in ListadoDeFechas" :key="fechas.Id" :value="fechas.Id" >{{fechas.FechaFormato}}</option>
                                    </select>
                                </div>
                            </div>
                            <div v-if="ListaConFormato.length>0">
                                <h6>Listado de Documentos en fecha seleccionada, total : {{ListaConFormato.length}}</h6>
                            </div>
                            <div id="noRegistradas_table" class="table-reponsive">
                                <table class="table table-striped table-light table-bordered table-sm">
                                    <thead class="thead-dark">
                                        <tr>
                                        <th></th>
                                        <th>Documento</th>
                                        <th>Sede</th>
                                        <th>Fecha de Envio</th>
                                        <th>Anexos</th>
                                        <th>Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-dark" v-for="Lista in ListaConFormato" :key="Lista.InventarioDocumentoId">
                                        <tr>
                                            <td width="20" class="category_enabled text-center">
                                                <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)"/>
                                            </td>
                                            <td width="350" v-html="TipoDocumentoHTML(Lista)"></td >
                                            <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                            <td width="150" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                            <!-- <td width="600" v-html="DesglosaContenido(Lista.Volumenes)"></td>  -->
                                            <!-- <td width="400">Volumen No: {{Lista.Volumenes.NumVolumen}}</td>  -->
                                            <td width="400" v-html="ConteoTomos(Lista)"></td>
                                            <td width="20" class="category_enabled text-center">
                                                <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div>
                                    <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                                </div>
                                
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-4 text-left">
                                <button class="btn btn-sm btn-success" @click='RecibirNoRegistradas()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                            </div>
                            <div class="form-group col-4 text-left">
                                <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">&nbsp;&nbsp;Eliminar de Listado&nbsp;&nbsp;</button>
                            </div>
                        </div>
            </div>
        </div>
    </div>
    <div v-if="this.Detalles==true">
        <Modal :Solicitudes="this.DatosEnvio" @dialogo='EstatusModal($event)'></Modal>
    </div>

</div>

</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import ModalDetalles from '@/components/ArchivoJudicial/Comun/DetalleSolicitud.vue'
import LogoPJE from '@/../src/assets/logo-pj-transparente-negro.png'

export default {
    components:{
      CAreas : catalogos.ArchivoJudicial.C001Areas,
      Modal: ModalDetalles
    }, 
    data(){
        return{
            enumeraciones,
            Detalles: false,
            BusquedaForm: {
                parametros_Area: {
                    areaId: -1,
                    conMaterias: true,
                    Materias: [ { MateriaId: 1, Activo: true },{ MateriaId: 2, Activo: true }, { MateriaId: 3, Activo: true }, { MateriaId: 4, Activo: true }, { MateriaId: 5, Activo: true } , { MateriaId: 6, Activo: true }, { MateriaId: 9, Activo: true }, { MateriaId: 13, Activo: true } ], 
                    conOrdenamientoPorSistema:true
                }
            },
            Solicitudes: [],
            DatosEnvio: {},
            Devoluciones: [],
            UsuarioArchivo: {},
            NoRegistradas : [],
            ListaConFormato : [],
            ARecibir:[],
            EliminarDeLista : [],
            listaPreviaSinFiltro : [],
            ListadoDeFechas:[]
        }
    },
    methods: {
        cambioDeArea(datos){
            this.BusquedaForm.parametros_Area.areaId = parseInt(datos[0].target.value);
        },
        ObtenSolicitudes(){
            //Obtiene lista de Solicitudes por Area Seleccionada
           this.ListadoDeFechas = [];
           this.listaPreviaSinFiltro = [];
           this.ListaConFormato = [];
            var peticion = {
                "AreaId" : this.BusquedaForm.parametros_Area.areaId
            };
            //$('#navRecepcion_table').remove();
            $('#navnoRegistradas_table').remove();
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.DevolucionArchivo, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {   
                    this.Solicitudes = respuesta.data.GetSolicitudes;
                    this.Solicitudes.sort((a,b)=>(a.InventarioDocumentos.CodigoBarras>b.InventarioDocumentos.CodigoBarras ? 1:-1));
                    this.NoRegistradas = respuesta.data.SolicitudesNoRegistradas;
                    
                    
                    
                    this.UsuarioArchivo = respuesta.data.UsuarioArchivo;
                    if(this.NoRegistradas.length>0)
                    {
                        this.DarFormatoListado(this.NoRegistradas);
                        // this.ListaConFormato.sort(this.sortAnioConsecutivo);
                        // this.$nextTick(()=> { PaginarTabla('noRegistradas_table', 15)});
                    };

                    if(this.Solicitudes.length==0 && this.NoRegistradas.length== 0)
                    {
                        comun.mensajeDeAlerta("No hay solicitudes en Devolución", null, null);
                    }
                }
                comun.SeEstaCargandoInformacion(false);
                
                })
                .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
                
            })
        },
        obtenFechaConFormato: function(fechaRegistro) {
        //   var Fecha;
        //   $.each(fechaRegistro, function(index, fecha)
        //   {
        //     Fecha = fecha.FechaMovimiento;
        //   })
            return moment(fechaRegistro).format("DD-MM-YYYY");
        },
        obtenFechaConFormatoSolicitudes: function(fechaRegistro) {
            return moment(fechaRegistro).format("DD-MM-YYYY");
        },
        DetallesVolumen: function(datos){
            this.DatosEnvio =  datos;
            this.Detalles = true;
        },
        Devolucion(){
            var MovimientosDocumentos =[];
            var usrArchivo= this.UsuarioArchivo;
            let SolicitudesAutorizadas =  this.SeleccionSolicitudes();
            if(SolicitudesAutorizadas.length > 0)
            {
                $.each(SolicitudesAutorizadas, function(indice, solicitud)
                {
                        $.each(solicitud.VolumenesEnSolicitud, function (indice, volsId){
                                MovimientosDocumentos.push({
                                    MovimientoDocumentoId : volsId.Volumenes.MovimientoVolumen.MovimientoDocumentoId,
                                    UsuarioQuienRecibe : usrArchivo
                                    //FechaRecepcion : moment().format('YYYY-MM-DD HH:MM:SS')
                                }); 
                                if(volsId.Volumenes.Amparos!=null && volsId.Volumenes.Amparos.length>0)
                                    {
                                        $.each(volsId.Volumenes.Amparos, function (id, amparo)
                                        {
                                            MovimientosDocumentos.push({
                                                MovimientoDocumentoId : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.MovimientoDocumentoId,
                                                UsuarioQuienRecibe : usrArchivo
                                            });
                                        })
                                }
                        });
                        $.each(solicitud.IncidentesEnSolicitud, function (indice, volsId){
                                MovimientosDocumentos.push({
                                    MovimientoDocumentoId : volsId.Incidentes.MovimientoIncidente.MovimientoDocumentoId,
                                    UsuarioQuienRecibe : usrArchivo
                                    //FechaRecepcion : moment().format('YYYY-MM-DD HH:MM:SS')
                                });       
                        });
                        $.each(solicitud.TerceriasEnSolicitud, function (indice, volsId){
                                MovimientosDocumentos.push({
                                    MovimientoDocumentoId : volsId.Tercerias.MovimientoTerceria.MovimientoDocumentoId,
                                    UsuarioQuienRecibe : usrArchivo
                                    //FechaRecepcion : moment().format('YYYY-MM-DD HH:MM:SS')
                                });       
                        });
                });
                let peticion = {
                    SolicitudesAutorizadas,
                    MovimientosDocumentos
                    };
                   
                        comun.SeEstaCargandoInformacion(true);
                        axios.post(api.conexion + api.ArchivoJudicial.CambiaEstadoSolicitud, peticion, comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                        ).then(respuesta => {
                            if(respuesta.data.SiHayError)
                                {
                                    console.log(respuesta);
                                    comun.SeEstaCargandoInformacion(false);
                                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                                }
                            else
                                {   
                                    this.ObtenSolicitudes();
                                    this.Devoluciones = [];
                                    this.NoRegistradas = [];
                                    this.ListaConFormato = [];
                                    comun.SeEstaCargandoInformacion(false);  
                                    comun.mensajeDeAlerta("Se han Recibído las Devoluciones Seleccionadas", null, null);
                                }
                                
                            
                        }).catch(excepcion => {
                            this.Devoluciones = [];
                            SolicitudesAutorizadas=[];
                            console.log(excepcion);
                            comun.SeEstaCargandoInformacion(false);
                            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        });

            }
            else
            {
                comun.mensajeDeAlerta("Seleccione Solicitudes para Recepción", null, null);
            }

        },
        EstatusModal(valor){
            this.Detalles = valor;
        },
        SeleccionSolicitudes(){
            let solicitudesSeleccionadas = [];
            this.Devoluciones.forEach((element) =>{
                let agregaSolicitud = this.Solicitudes.find(sol=>sol.SolicitudDocumentoId == element);
                agregaSolicitud.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId = 4;
                solicitudesSeleccionadas.push(agregaSolicitud);
            });
            return solicitudesSeleccionadas;
        },
        GenerarPrint: function(Listado, usrArchivo){
                var UsuariosFirmas =[];
            UsuariosFirmas.push({"Nombre": usrArchivo.Nombre, "ApPaterno": usrArchivo.ApellidoPaterno, "ApMaterno": usrArchivo.ApellidoMaterno, "Area": usrArchivo.AreaAsignado.Nombre});
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12">');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-3 align-self-center">');
            printWin.document.write('<img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">LISTADO DE SOLICITUDES EN DEVOLUCION</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h6 class="text-center">RECEPCIÓN DE DOCUMENTOS</h6>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 text-right">');
            printWin.document.write('<label>Aguascalientes, Ags., a  '+ moment().format('DD/MM/YYYY') + '</label>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 ">');
            printWin.document.write('<label>Area: '+ this.AreaEtiqueta +'</label>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12">');
            printWin.document.write('<div class="table-reponsive">');
            printWin.document.write('<table class="table table-striped table-light table-hover">');
            printWin.document.write('<thead><tr><th >Solicitud No.</th><th >Documento</th><th >Consecutivo</th><th >Solicitado por:</th>');
            printWin.document.write('<th>Observaciones</th><th>Volumenes en Solicitud</th><th></th></tr></thead><tbody class="text-dark">');
            //ciclo inicio
            $.each(Listado, function(index, SolicitudesImpresion){

                var rows = SolicitudesImpresion.VolumenesEnSolicitud.length + SolicitudesImpresion.IncidentesEnSolicitud.length + 1;

                var Detalle = SolicitudesImpresion.ObservacionesArchivo !=null ? SolicitudesImpresion.ObservacionesArchivo : "";
                if(Detalle!="")
                {
                    Detalle=Detalle + "<br/>";
                };
                let contenido="";
                
                if(SolicitudesImpresion.VolumenesEnSolicitud.length>0)
                {
                    $.each(SolicitudesImpresion.VolumenesEnSolicitud, function(index, enSolicitud)
                    {
                        if(enSolicitud.Volumenes.IncidenteVolumen.length>0)
                        {
                            contenido =  contenido + "Volumen No: " + enSolicitud.Volumenes.NumVolumen + " Contiene:" + "<br/>";
                            $.each(enSolicitud.Volumenes.IncidenteVolumen, function (index, contenidoVolumenes)
                            {
                                contenido = contenido + "Incidente No: "+ contenidoVolumenes.NumeroIncidente + ", Tipo: " + contenidoVolumenes.TipoIncidente + "<br/>";
                            });
                        };
                        if(enSolicitud.Volumenes.TerceriaVolumen.length>0)
                        {
                            contenido =  contenido + "Volumen No: " + enSolicitud.Volumenes.NumVolumen + " Contiene:" + "<br/>";
                            $.each(enSolicitud.Volumenes.TerceriaVolumen, function (index, contenidoVolumenes)
                            {
                                contenido = contenido + "Terceria No: "+ contenidoVolumenes.NumeroTerceria + ", Tipo: " + contenidoVolumenes.TipoTerceria + "<br/>";
                            });
                        }
                    })
                }

                
                printWin.document.write('<tr>');
                printWin.document.write('<td rowspan="'+ rows +'">'+ SolicitudesImpresion.SolicitudDocumentoId +'</td>');
                printWin.document.write('<td rowspan="'+ rows +'">'+ SolicitudesImpresion.InventarioDocumentos.TipoDocumento.Nombre +'</td>');
                printWin.document.write('<td rowspan="'+ rows +'">'+ SolicitudesImpresion.InventarioDocumentos.Consecutivo +'/' + SolicitudesImpresion.InventarioDocumentos.Anio +'</td>');
                printWin.document.write('<td rowspan="'+ rows +'">'+ SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre
                                              + ' ' + SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno
                                              + ' ' + SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno +'</td>');
                printWin.document.write('<td rowspan="'+ rows +'">'+ Detalle + contenido +'</td>');
                printWin.document.write('</tr>');
                $.each(SolicitudesImpresion.VolumenesEnSolicitud, function(index, Volumenes)
                {
                    printWin.document.write('<tr>');
                    printWin.document.write('<td>Volumen: '+ Volumenes.Volumenes.NumVolumen + '</td>');
                    printWin.document.write('<td>Fojas: '+ Volumenes.Volumenes.Fojas + '</td>');
                    printWin.document.write('</tr>');
                });
                $.each(SolicitudesImpresion.IncidentesEnSolicitud, function(index, Incidentes)
                {
                    printWin.document.write('<tr>');
                    printWin.document.write('<td>Incidente: '+ Incidentes.Incidentes.NumeroIncidente + '</td>');
                    printWin.document.write('<td>Tipo: '+ Incidentes.Incidentes.TipoIncidente + '</td>');
                    printWin.document.write('</tr>');
                });

                var Existe = UsuariosFirmas.findIndex(datos => datos.Nombre == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre &&
                                                    datos.ApPaterno == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno &&
                                                    datos.ApMaterno == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno);
                if(Existe == -1)
                    {
                        UsuariosFirmas.push({
                                "Nombre": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre,
                                "ApPaterno": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno,
                                "ApMaterno": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno,
                                "Area": SolicitudesImpresion.Juzgado.AreaIdQueSolicita.Nombre
                                            });
                    }

            });
            //ciclo fin

            printWin.document.write('</tbody></table></div></div></div>');
            printWin.document.write('<div class="area">');
            var Cuadros = UsuariosFirmas.length;
            switch (Cuadros)
            {
                case 2:
                    {
                        printWin.document.write('<div class="row">');
                        printWin.document.write('<div class="form-group col-1"></div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[0].Nombre + ' '+ UsuariosFirmas[0].ApPaterno + ' '+ UsuariosFirmas[0].ApMaterno + '</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>' + UsuariosFirmas[0].Area + '</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-2"></div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[1].Nombre + ' '+ UsuariosFirmas[1].ApPaterno + ' '+ UsuariosFirmas[1].ApMaterno + '</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>' + UsuariosFirmas[1].Area + '</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-1"></div>');
                        printWin.document.write('</div>');
                        break;
                    }
                case 3:
                    {
                        printWin.document.write('<div class="row">');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[0].Nombre + ' '+ UsuariosFirmas[0].ApPaterno + ' '+ UsuariosFirmas[0].ApMaterno + '</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>' + UsuariosFirmas[0].Area + '</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[1].Nombre + ' '+ UsuariosFirmas[1].ApPaterno + ' '+ UsuariosFirmas[1].ApMaterno + '</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>' + UsuariosFirmas[1].Area + '</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[2].Nombre + ' '+ UsuariosFirmas[2].ApPaterno + ' '+ UsuariosFirmas[2].ApMaterno + '</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>' + UsuariosFirmas[2].Area + '</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('</div>');
                        break;
                    }
                case 4:
                    {
                        printWin.document.write('<div class="row">');
                        printWin.document.write('<div class="form-group col-1"></div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[0].Nombre + ' '+ UsuariosFirmas[0].ApPaterno + ' '+ UsuariosFirmas[0].ApMaterno + '</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>' + UsuariosFirmas[0].Area + '</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-2"></div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[1].Nombre + ' '+ UsuariosFirmas[1].ApPaterno + ' '+ UsuariosFirmas[1].ApMaterno + '</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>' + UsuariosFirmas[1].Area + '</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-1"></div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="row">');
                        printWin.document.write('<div class="form-group col-1"></div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[2].Nombre + ' '+ UsuariosFirmas[2].ApPaterno + ' '+ UsuariosFirmas[2].ApMaterno + '</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>' + UsuariosFirmas[2].Area + '</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-2"></div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[3].Nombre + ' '+ UsuariosFirmas[3].ApPaterno + ' '+ UsuariosFirmas[3].ApMaterno + '</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>' + UsuariosFirmas[3].Area + '</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-1"></div>');
                        printWin.document.write('</div>');
                        break;
                    }
            }

            printWin.document.write('</div>');
            printWin.document.write('</div>');

            printWin.document.write('</body></html>');
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        },
        DarFormatoListado(Lista){
            var FechasEnLista= []
            var ListaPreliminar =[];
            $.each(Lista, function (index, movIds){
                
                ListaPreliminar.push(
                    {
                    "MovimientoDocumentoId": movIds.MovimientoDocumentoId,
                    "SolicitudDocumentoId": movIds.SolicitudDocumentoId,
                    "InventarioDocumentoId": movIds.VolumenId !=null ? movIds.Volumen.Inventario.InventarioDocumentoId : (movIds.IncidenteId !=null ? movIds.Incidente.Inventario.InventarioDocumentoId : movIds.Terceria.Inventario.InventarioDocumentoId),
                    "TipoDocumento": movIds.VolumenId !=null ? movIds.Volumen.Inventario.TipoDocumento : (movIds.IncidenteId != null ? movIds.Incidente.Inventario.TipoDocumento : movIds.Terceria.Inventario.TipoDocumento),
                    "Materia": movIds.VolumenId !=null ? movIds.Volumen.Inventario.Materia : (movIds.IncidenteId != null ? movIds.Incidente.Inventario.Materia : movIds.Terceria.Inventario.Materia),
                    "Anexos": movIds.VolumenId !=null ? movIds.Volumen.Inventario.Anexos : (movIds.IncidenteId != null ? movIds.Incidente.Inventario.Anexos : movIds.Terceria.Inventario.Anexos),
                    "Anio": movIds.VolumenId !=null ? movIds.Volumen.Inventario.Anio : ( movIds.IncidenteId !=null ? movIds.Incidente.Inventario.Anio : movIds.Terceria.Inventario.Anio),
                    "Consecutivo": movIds.VolumenId !=null ? movIds.Volumen.Inventario.Consecutivo : (movIds.IncidenteId!= null ? movIds.Incidente.Inventario.Consecutivo : movIds.Terceria.Inventario.Consecutivo),
                    "AreaQuePresta": movIds.AreaQuePresta,
                    "UsuarioQuienPresta": movIds.UsuarioQuienPresta,
                    "FechaMovimiento": movIds.FechaMovimiento,
                    "VolumenId": movIds.VolumenId !=null ? movIds.VolumenId : null,
                    "Volumen": movIds.Volumen !=null ? movIds.Volumen : null,
                    "IncidenteId": movIds.IncidenteId !=null ? movIds.IncidenteId : null,
                    "Incidente": movIds.Incidente !=null ? movIds.Incidente: null,
                    "TerceriaId": movIds.TerceriaId !=null ? movIds.TerceriaId : null,
                    "Terceria": movIds.Terceria !=null ? movIds.Terceria : null,
                    "SedeArchivo": movIds.VolumenId !=null ? movIds.Volumen.Inventario.SedeArchivo : ( movIds.IncidenteId!=null ? movIds.Incidente.Inventario.SedeArchivo : movIds.Terceria.Inventario.SedeArchivo),
                    "Observaciones": movIds.Observaciones,
                    "TiposMovimientos": movIds.TiposMovimientos,
                    "FechaRecepcion": movIds.FechaRecepcion
                    })
            });
            
            var temporal = this.AgruparInventarioDocumentoId(ListaPreliminar);
            this.listaPreviaSinFiltro = temporal.filter(e=>e.Volumenes.Inventario.AmparoDocumentoPrincipal==null);
            $.each(this.listaPreviaSinFiltro, function(id, elemento){
                var checkFecha = FechasEnLista.find(e=>e.FechaMovimiento==elemento.FechaMovimiento);
                if(checkFecha==undefined || checkFecha==false)
                {
                    FechasEnLista.push({
                         "Id": id,
                            "FechaMovimiento": elemento.FechaMovimiento,
                            "FechaFormato" : moment(elemento.FechaMovimiento).format('DD/MM/YYYY')
                    })
                }
            });
            this.ListadoDeFechas = FechasEnLista.sort((a,b)=>(a.FechaMovimiento>b.FechaMovimiento ? 1:-1));
            //this.ListaConFormato= temporal.filter(e=>e.Volumenes.Inventario.AmparoDocumentoPrincipal==null);
        },
        AgruparInventarioDocumentoId(datos){
            var ListaInicial=[];
            $.each(datos, function(index, listado){
                var chequeo = ListaInicial.find(e=>e.InventarioDocumentoId == listado.InventarioDocumentoId);
                if(chequeo == undefined || chequeo == false)
                {
                    ListaInicial.push({"InventarioDocumentoId": listado.InventarioDocumentoId,
                                    "TipoDocumento": listado.TipoDocumento,
                                    "Anio": listado.Anio,
                                    "Consecutivo": listado.Consecutivo,
                                    "SedeArchivo": listado.SedeArchivo,
                                    "Volumenes": listado.Volumen,
                                    "FechaMovimiento": listado.FechaMovimiento,
                                    "Anexos": listado.Anexos,
                                    "Materia" : listado.Materia,
                                    "Movimientos": [
                                    {
                                        "MovimientoDocumentoId": listado.MovimientoDocumentoId,
                                        "SolicitudDocumentoId": listado.SolicitudDocumentoId,
                                        "FechaMovimiento": listado.FechaMovimiento,
                                        "UsuarioQuienPresta": listado.UsuarioQuienPresta,
                                        "AreaQuePresta": listado.AreaQuePresta,
                                        "IncidenteId": listado.IncidenteId,
                                        "Incidentes": listado.Incidente!= null? listado.Incidente : null,
                                        "VolumenId": listado.VolumenId,
                                        "Volumenes": listado.Volumen!=null ? listado.Volumen : null,
                                        "TerceriaId": listado.TerceriaId,
                                        "Tercerias": listado.Terceria!=null ? listado.Terceria : null,
                                        "TiposMovimientos": listado.TiposMovimientos,
                                        "FechaRecepcion":listado.FechaRecepcion
                                    }],
                                    "Observaciones": listado.Observaciones
                                    });
                }
                else{
                    chequeo.Movimientos.push({
                                        "MovimientoDocumentoId": listado.MovimientoDocumentoId,
                                        "SolicitudDocumentoId": listado.SolicitudDocumentoId,
                                        "FechaMovimiento": listado.FechaMovimiento,
                                        "UsuarioQuienPresta": listado.UsuarioQuienPresta,
                                        "AreaQuePresta": listado.AreaQuePresta,
                                        "IncidenteId": listado.IncidenteId,
                                        "Incidentes": listado.Incidente!= null? listado.Incidente : null,
                                        "VolumenId": listado.VolumenId,
                                        "Volumenes": listado.Volumen!=null ? listado.Volumen : null,
                                        "TerceriaId": listado.TerceriaId,
                                        "Tercerias": listado.Terceria!=null ? listado.Terceria : null,
                                        "TiposMovimientos": listado.TiposMovimientos,
                                        "FechaRecepcion":listado.FechaRecepcion});
                    
                }
                
            });
            return ListaInicial;
        },
        RecibirNoRegistradas() {
             var Movimientos = [];
             let Documentos = this.Seleccion();
             var ListaRecepcion = [];
             let _this = this;
             if(Documentos.length>0)
             {
               //console.log(Documentos)
               $.each(Documentos, function(indice, documento)
                {
                  //ListaRecepcion.push(documento.InventarioDocumentoId);
                  $.each(documento.Movimientos, function(indice, movimiento)
                  {
                    Movimientos.push(movimiento);
                    if(movimiento.SolicitudDocumentoId!=null)
                    {
                        var checaSolicitud = ListaRecepcion.find(e=>e == movimiento.SolicitudDocumentoId);
                        if(checaSolicitud == undefined || checaSolicitud == false)
                        {
                            ListaRecepcion.push(movimiento.SolicitudDocumentoId)
                        }
                    }

                  });
                  
                  if(documento.Volumenes.Inventario.Volumenes[0].Amparos!=null && documento.Volumenes.Inventario.Volumenes[0].Amparos.length>0)
                  {
                    $.each(documento.Volumenes.Inventario.Volumenes[0].Amparos, function(id, amparo)
                    {
                      Movimientos.push(amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen);
                      //ListaRecepcion.push(amparo.AmparosDelDocumento.InventarioDocumentoId)
                    });
                  }

                });
               var peticion={
                    Movimientos, ListaRecepcion
                };
                
              this.AreaEtiqueta = this.BusquedaForm.parametros_Area.Nombre;
              comun.SeEstaCargandoInformacion(true);
              axios.post(api.conexion + api.ArchivoJudicial.RecepcionDevolucion, peticion,
              comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
              .then( respuesta => {
              if(respuesta.data.SiHayError)
                {
                  console.log(respuesta);
                  comun.SeEstaCargandoInformacion(false);
                  comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                  this.ARecibir = [];
                }
                else
                {   
                  //comun.mensajeDeAlerta("Se Registrado la Recepción de Documento en Archivo.");
                  var usuario = this.UsuarioArchivo;
                  
                    comun.SeEstaCargandoInformacion(false);
                    
                    this.ARecibir = [];
                    $.each(Documentos, function(id, elemento){
                        var indice = _this.ListaConFormato.indexOf(elemento);
                        _this.ListaConFormato.splice(indice,1);

                    })
                    if(this.ListaConFormato.length==0)
                    {
                        this.ObtenSolicitudes();
                    }           
                }
                comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                console.log(excepcion);
                console.log("fallo por parametros");
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
                });
              }
              else
              {
                  comun.mensajeDeAlerta("Seleccione Documentos para Recepción", null, null);
              }
        },
        Seleccion(){
                let documentosSeleccionados = [];
                this.ARecibir.forEach((element) =>{
                    let agregaDocumento = this.ListaConFormato.find(sol=>sol.InventarioDocumentoId == element);
                    documentosSeleccionados.push(agregaDocumento);
                });
                return documentosSeleccionados;
        },
        DesglosaContenido: function (datos){
            //console.log(datos)
            let Contenido ="";
            $.each(datos, function(index, movimiento)
            {
            if(movimiento.Volumenes!=null)
                {   
                    //var ListaAnexos = movimiento.Volumenes.AnexosVolumen !=null ? movimiento.Volumenes.AnexosVolumen : [];
                    var ListaIncidentes = movimiento.Volumenes.IncidenteVolumen != null ? movimiento.Volumenes.IncidenteVolumen : [];
                    var ListaAmparos = movimiento.Volumenes.Amparos !=null ? movimiento.Volumenes.Amparos : [];
                        Contenido= Contenido + "<b class='text-primary'>TOMO NO. " + movimiento.Volumenes.NumVolumen + "</b><br/>";
                        
                        // if(ListaAmparos.length>0)
                        // {
                        // Contenido= Contenido +"<b class='text-info'>AMPAROS</b><br/>";
                        //         $.each(ListaAmparos, function(index, enVolumen)
                        //         {
                        //         Contenido = Contenido + "Consecutivo: "+ enVolumen.Consecutivo +  "<br/>";
                        //         })
                        // };
                        // if(ListaIncidentes.length>0)
                        //     {
                        //     Contenido = Contenido +"<b class='text-info'>INCIDENTES FUERA DE CUERDAS</b><br/>";
                        //         $.each(ListaIncidentes, function(index, enVolumen)
                        //         {
                        //         Contenido = Contenido + "No: "+ enVolumen.NumeroIncidente + ",  Tipo: " + enVolumen.TipoIncidente + "<br/>";
                        //         })
                        // }
                }
                if(datos.Incidentes!=null)
                {
                    Contenido= Contenido +"<b class='text-primary'>INCIDENTES FUERA DE CUERDAS</b><br/>";
                            $.each(datos.Incidentes, function(index, enVolumen)
                            {
                            Contenido = Contenido + "Cantidad: "+ enVolumen.NumeroIncidente + ",  Observaciones: " + enVolumen.TipoIncidente + "<br/>";
                            })
                }
                if(datos.Tercerias!=null)
                {
                    Contenido= Contenido +"<b class='text-primary'>TERCERIAS</b><br/>";
                            $.each(datos.Tercerias, function(index, enVolumen)
                            {
                            Contenido = Contenido + "Cantidad: "+ enVolumen.NumeroTerceria + ",  Observaciones: " + enVolumen.TipoTerceria + "<br/>";
                            })
                }
            });
           
            
            return Contenido;
        },
        ConteoTomos: function (datos){
            let contenido ="";
            let contadorTomos = datos.Movimientos.filter(e=>e.VolumenId!=null);
            let contadorIncidentes = datos.Movimientos.filter(e=>e.IncidenteId!=null);
            let contadorTercerias = datos.Movimientos.filter(e=>e.TerceriaId!=null);
            if (datos.Anexos!=null)
            {
                contenido=contenido + datos.Anexos + '<br/>'
            }
            return contenido;
            
        },
        sortAnioConsecutivo: function (a,b)
        {
            if(a.TipoDocumento.TipoDocumentoId < b.TipoDocumento.TipoDocumentoId) return -1
            if(a.TipoDocumento.TipoDocumentoId > b.TipoDocumento.TipoDocumentoId) return 1
            if(a.Anio < b.Anio) return -1
            if(a.Anio > b.Anio) return 1
            if(a.Consecutivo < b.Consecutivo) return -1
            if(a.Consecutivo > b.Consecutivo) return 1
            return 0
        },
        ChecaEliminar(evento, id){
        if(evento.target.checked)
        {
          var buscaEnRecepcion = this.ARecibir.filter(e=>e == id);
          if(buscaEnRecepcion.length>0)
          {
            comun.mensajeDeAlerta("Este documento fue seleccionado en recepción, cambia a selección en eliminación", null, null);
            let index = this.ARecibir.indexOf(id);
            this.ARecibir.splice(index,1);
          }
        }
        },
        ChecaRecepcion(evento, id){
            if(evento.target.checked)
            {
            var buscaEnElimina = this.EliminarDeLista.filter(e=>e == id);
            if(buscaEnElimina.length>0)
            {
                comun.mensajeDeAlerta("Este documento fue seleccionado en eliminación, cambia a selección en recepción", null, null);
                let index = this.EliminarDeLista.indexOf(id);
                this.EliminarDeLista.splice(index,1);
            }
            }
        },
        Eliminar(){
            var MovimientosAEliminar = [];
            let Documentos = this.seleEliminar();
            let _this = this;
            $.each(Documentos, function(indice, documento)
            {
            $.each(documento.Movimientos, function(indice, movimiento)
                {
                    MovimientosAEliminar.push(movimiento)
                });
            });
            var peticion = {MovimientosAEliminar}
            bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Desea Eliminar los documentos seleccionados en Recepción?",
            buttons: {
                cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                },
                confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                }
            },
            callback: (respuestaSalir) => {
                if (respuestaSalir) {
                //comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.EliminarDeLista, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                if(respuesta.data.SiHayError)
                    {
                    console.log(respuesta);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    this.ARecibir = [];
                    }
                    else
                    {   
                    //comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    $.each(Documentos, function(id, eliminado)
                    {
                        var indice = _this.ListaConFormato.indexOf(eliminado);
                        _this.ListaConFormato.splice(indice,1);
                    })
                    this.EliminarDeLista = [];
                    if(this.ListaConFormato.length==0)
                    {
                        this.ObtenSolicitudes();
                    }
                    //this.ObtenSolicitudes();
                    //this.ARecibir = [];
                    //this.EliminarDeLista = [];
                    // this.ListaConFormatoExpedientes = [];
                    // this.ListaConFormatoAmparos = [];
                    // this.ListaConFormatoExhortos = [];
                    // this.ListaConFormatoOtros=[];
                    }
                    //comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                }); 
                }
            }
            });
        },
        seleEliminar(){
        let documentosSeleccionados = [];
        
            this.EliminarDeLista.forEach((element) =>{
              let agregaDocumentoExpediente = this.ListaConFormato.find(sol=>sol.InventarioDocumentoId == element);
              
                if(agregaDocumentoExpediente!=undefined)
                {
                    documentosSeleccionados.push(agregaDocumentoExpediente);
                }
            });
            return documentosSeleccionados;
        },
        cambiarFechaListado(datos){
            var obtenido = parseInt(datos.target.value);
            this.ARecibir=[];
            this.EliminarDeLista=[];
            $('#navnoRegistradas_table').remove();
            //console.log(this.listaPreviaSinFiltro)
            if (obtenido>=0)
            {
                var fecha=this.ListadoDeFechas.find(a=>a.Id==obtenido);
                this.ListaConFormato = this.listaPreviaSinFiltro.filter(z=>z.FechaMovimiento==fecha.FechaMovimiento);
                this.ListaConFormato.sort(this.sortAnioConsecutivo);
                this.$nextTick(()=> { PaginarTabla('noRegistradas_table', 15)});
            }
            else
            {
                this.ListaConFormato = [];
            }
        },
        TipoDocumentoHTML(datos){
            let tipo = '';
            //{{Lista.TipoDocumento.Nombre}} {{Lista.Consecutivo}}/{{Lista.Anio}}
            if(datos.Materia.MateriaId==6 || datos.Materia.MateriaId==9)
            {
                if(datos.TipoDocumento.TipoDocumentoId==1)
                {
                    tipo = "EXPEDIENTE PENAL" + " "  + datos.Consecutivo + "/" + datos.Anio
                };
                if(datos.TipoDocumento.TipoDocumentoId==4)
                {
                    tipo ="AMPARO PENAL" + " "  + datos.Consecutivo + "/" + datos.Anio
                };
                if(datos.TipoDocumento.TipoDocumentoId==5)
                {
                    tipo = "EXHORTO PENAL" + " "  + datos.Consecutivo + "/" + datos.Anio
                };
                if(datos.TipoDocumento.TipoDocumentoId==16)
                {
                    tipo = "TOCA PENAL" + " "  + datos.Consecutivo + "/" + datos.Anio
                };
                if(datos.TipoDocumento.TipoDocumentoId==23)
                {
                    tipo = datos.TipoDocumento.Nombre + " "  + datos.Consecutivo + "/" + datos.Anio
                }
                if(datos.TipoDocumento.TipoDocumentoId==24)
                {
                    tipo = datos.TipoDocumento.Nombre + " "  + datos.Consecutivo + "/" + datos.Anio
                }
                if(datos.TipoDocumento.TipoDocumentoId==26)
                {
                    tipo = datos.TipoDocumento.Nombre + " "  + datos.Consecutivo + "/" + datos.Anio
                }
                if(datos.TipoDocumento.TipoDocumentoId==27)
                {
                    tipo = datos.TipoDocumento.Nombre + " "  + datos.Consecutivo + "/" + datos.Anio
                }
                if(datos.TipoDocumento.TipoDocumentoId==29)
                {
                    tipo = "TOCA ORAL" + " "  + datos.Consecutivo + "/" + datos.Anio
                };
            }
            else
            {
                if(datos.TipoDocumento.TipoDocumentoId==16)
                {
                    tipo = "TOCA CIVIL" + " "  + datos.Consecutivo + "/" + datos.Anio
                }
                else
                {
                    tipo = datos.TipoDocumento.Nombre + " "  + datos.Consecutivo + "/" + datos.Anio
                }
                
            }
            return tipo;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Solicitudes/SolicitudesDevolucion.vue